import { render, staticRenderFns } from "./IotAlertHistory.vue?vue&type=template&id=38d7d5ea&scoped=true&"
import script from "./IotAlertHistory.vue?vue&type=script&lang=js&"
export * from "./IotAlertHistory.vue?vue&type=script&lang=js&"
import style0 from "./IotAlertHistory.vue?vue&type=style&index=0&id=38d7d5ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d7d5ea",
  null
  
)

export default component.exports